import React from 'react';

import { Typography } from '@mui/material';

export const renderFormLabel = (label: string): JSX.Element => (
  <Typography component="div" color="textSecondary" variant="body2">
    {label}
  </Typography>
);
